function firstNonEmpty(candidates) {
  for (const value of candidates) {
    if (value == null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return null;
}

function readRuntimePublicSiteToken(runtime) {
  if (runtime && typeof runtime === "object") {
    const fromArg = firstNonEmpty([
      runtime.siteId,
      runtime.resolvedSiteId,
      runtime.public_site_id,
      runtime.agent_public_site_id,
    ]);
    if (fromArg) return fromArg;
  }
  if (typeof window === "undefined") return null;
  const fromUrl = new URLSearchParams(window.location.search || "").get("siteId");
  const ctx = window.__HR_PUBLIC_SITE_IDENTITY_CONTEXT;
  return firstNonEmpty([
    fromUrl,
    ctx?.resolvedSiteId,
    ctx?.siteId,
    ctx?.siteRef,
  ]);
}

/** Keys production `/searchLds` treats as a public-site token (`_extract_search_public_site_id`). */
export const PUBLIC_LDS_INVENTORY_SITE_TOKEN_KEYS = [
  "siteId",
  "site_id",
  "resolvedSiteId",
  "resolved_site_id",
  "public_site_id",
  "publicSiteId",
  "agent_public_site_id",
];

/**
 * Forward the public site identity for findById / create / checkout — not inventory
 * `/searchLds`. Never invent a snapshot id here.
 */
export function attachPublicSiteTokenToLdsSearchBody(data, runtime) {
  const body =
    data != null && typeof data === "object" && !Array.isArray(data) ? { ...data } : {};
  const token =
    firstNonEmpty([
      body.siteId,
      body.site_id,
      body.resolvedSiteId,
      body.resolved_site_id,
      body.public_site_id,
      body.agent_public_site_id,
      body.publicSiteId,
    ]) || readRuntimePublicSiteToken(runtime);
  if (!token) return body;
  body.siteId = token;
  if (!body.resolvedSiteId) body.resolvedSiteId = token;
  if (!body.public_site_id) body.public_site_id = token;
  if (!body.agent_public_site_id) body.agent_public_site_id = token;
  return body;
}

/**
 * Production `/searchLds` with a public site token runs
 * `_limit_public_search_return_set` (PUBLIC_VP_SEARCH_RETURN_LIMIT, default 40)
 * then `drop_public_search_deals_without_snapshot`. That is the 15 hotels / 34
 * packages cap. The same payload without siteId returns the full LDS page
 * (500 deals / 154 hotels for כל היעדים). Checkout still sends the token on
 * findById / create.
 */
export function stripPublicSiteTokenFromLdsInventorySearchBody(data) {
  const body =
    data != null && typeof data === "object" && !Array.isArray(data) ? { ...data } : {};
  for (const key of PUBLIC_LDS_INVENTORY_SITE_TOKEN_KEYS) {
    delete body[key];
  }
  return body;
}
